<template>
  <main-layout
    margin-top="-20px"
    regular
  >
    <base-breadcrumb :routes="routes" style="margin-bottom: 10px;" />
    <div
      class="row"
    >
      <div class="col-12">
        <admin-profile-container />
      </div>
    </div>
    <div
      v-if="isIntegrated"
      class="row"
    >
      <div class="col-12 mb-3">
        <sales-summary-container
          :data-range="dataRange"
          :profile="profile"
        />
      </div>
    </div>
    <!-- start card -->
    <div class="row mt-4">
      <div class="col-12">
        <base-card class="data-range">
          <div class="row">
            <div class="col-12">
              <div class="row sticky">
                <div class="col-12">
                  <data-range-selector v-model="dataRange" />
                </div>
              </div>
            </div>
            <div class="col-6">
              <associate-activity-container
                :profile-id="profileId"
                :data-range="dataRange"
              />
            </div>
            <div class="col-6">
              <associate-performance-chart-container :data-range="dataRange" />
            </div>
          </div>
        </base-card>
      </div>
    </div>
    <!-- end -->
    <div class="row mt-4">
      <div class="col-12">
        <associate-outreach-list-container
          :profile-id="profileId"
          data-range="12m"
        />
      </div>
    </div>
  </main-layout>
</template>
<script>
import DataRangeSelector from '@/components/Widgets/Reports/DataRangeSelector';
import AssociateActivityContainer from '@/components/Widgets/AssociateReports/AssociateActivityContainer';
import AssociatePerformanceChartContainer from '@/components/Widgets/AssociateReports/AssociatePerformanceChartContainer';
import AssociateOutreachListContainer from '@/components/Widgets/AssociateReports/AssociateOutreachListContainer';
import AdminProfileContainer from '@/components/Widgets/AdminProfileContainer';
import SalesSummaryContainer from '@/components/Widgets/AssociateReports/SalesSummaryContainer';
import integrable from '@/components/mixins/integrable';
import { EventBus } from '@/event-bus';

export default {
  name: 'ProfileSummary',
  components: {
    SalesSummaryContainer,
    AdminProfileContainer,
    DataRangeSelector,
    AssociateActivityContainer,
    AssociatePerformanceChartContainer,
    AssociateOutreachListContainer,
  },
  mixins: [integrable],
  data() {
    return {
      profileName: '',
      dataRange: this.institutionDefaultDataRange,
    };
  },
  computed: {
    routes() {
      return [{
        name: 'Dashboard',
      }, {
        name: this.profileName,
      }];
    },
    profileId() {
      return this.$route.params.id;
    },
    profile() {
      return this.$store.state.profiles.item;
    },
    institutionDefaultDataRange() {
      return this.$store.state.account.user.profile.institution.reports_time_range;
    },
  },
  watch: {
    institutionDefaultDataRange: {
      handler(newval) {
        if (newval && !this.dataRange) this.dataRange = newval;
      },
      immediate: true,
    },
  },
  created() {
    EventBus.$on('profileBreadcrumb', (val) => {
      this.profileName = val;
    });
  },
  mounted() {
    this.$store.dispatch('profiles/fetchItem', this.profileId);
  },
};
</script>
<style lang="scss"
  scoped>
.sticky {
  position: sticky;
  position: -webkit-sticky;
  /* Safari */
  top: 60px;
  z-index: 10;
}
</style>
